import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";

export function OrganizacionesHeader({
  total,
  activas,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  activas: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Organizaciones"
      description={`Catálogo de las sociedades del Grupo Financiero Multiva · ${total} total · ${activas} activa(s).`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nueva organización
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
